import Gallery, { GalleryProps, Layout } from '.';

export const HERO_GALLERY_SIZE = 7;

export const HERO_GALLERY_LAYOUT: Layout = [
  [1, 1, 1, 2, 2],
  [3, 4],
  [3, 4],
];

const HeroGallery = ({ items, layout, soldOutHeaders }: GalleryProps) => {
  if (items.length !== HERO_GALLERY_SIZE) {
    console.warn(
      `Expected ${HERO_GALLERY_SIZE} items got ${items.length}.` +
        `Any extra/fewer items will create empty blocks in the layout on different screen sizes.`
    );
  }

  return (
    <Gallery
      items={items}
      layout={layout}
      isFirstRowAccented
      isFirstRowLarge
      preloadImages
      soldOutHeaders={soldOutHeaders}
    />
  );
};

export default HeroGallery;
